'use strict';

$('body').on('change', '#countrySelector', function (e) {
    e.preventDefault();
    var $this = $(this);
    var action = $('.page').data('action');
    var selectedoption = $this.children('option:selected');
    var localeCode = selectedoption.data('locale');
    var localeCurrencyCode = selectedoption.data('currencycode');
    var url = selectedoption.data('url');
    var queryString = $('.page').data('querystring');
    if (!url || !localeCode || !localeCurrencyCode) return;

    var isPageDesignerPage = window.location.href.indexOf('cid=') > -1;

    if (isPageDesignerPage) {
        var urlParams = new URLSearchParams(window.location.search);
        var cid = urlParams.get('cid');
        if (cid) {
            action = 'Page-Show';
            queryString = 'cid=' + cid;
        }
    }
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: {
            code: localeCode,
            queryString: queryString,
            CurrencyCode: localeCurrencyCode,
            action: action
        },
        success: function (response) {
            $.spinner().stop();
            if (response && response.redirectUrl) {
                window.location.href = response.redirectUrl;
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

